import { useGlobalState } from '@/hooks/use-global-state';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const useSocialFeedEnabled = () => {
    const socialFeedPrismicFlag = useJurisdictionStore(
        store => store.jurisdictionSettings?.productConfig?.settings?.social_feed_enabled
    );
    const socialFeedAPIEnabled = useGlobalState(state => state.entryFeedConfig?.socialFeedEnabled);
    const socialFeedEnabled = socialFeedPrismicFlag && socialFeedAPIEnabled;

    return socialFeedEnabled;
};
